/*
 * Desktop mega menu "Магазин", variant 1 · Індекс (snippets/mega-shop.liquid).
 * Behaviour per spec §7 (Downloads/Clean Project — мегаменю.zip, 16.10.2026):
 *
 *   open   pointer rests on "Магазин" for 120 ms, or Enter / Space / ↓;
 *          a click follows the link to the catalogue
 *   close  pointer leaves both trigger and panel (200 ms), click on the veil,
 *          Esc, or the page scrolls more than 80 px
 *   rows   hover or focus makes a row active: the others fade, the photo
 *          crossfades with a slow zoom, caption and "01 / 08" follow
 *   keys   ↑/↓ move between rows, Esc returns focus to "Магазин"
 *
 * Horizon re-renders the header after load, so nothing here holds on to a
 * node: the panel, its rows and the trigger are looked up when needed and
 * every listener is delegated from the document. The veil is moved to
 * <body> (inside the sticky header a fixed element is clipped to it).
 *
 * The cascade replays on every open (class off, reflow, class on). Photos
 * are created on the first approach to "Магазин", so the eight of them
 * never weigh on a page load that does not use the menu.
 */
(function () {
  if (!window.matchMedia) return;
  var desktop = window.matchMedia('(min-width: 1024px)');

  var openTimer = null;
  var closeTimer = null;
  var isOpen = false;
  var openScrollY = 0;
  var lastTrigger = null;

  function P() { return document.getElementById('mega-shop'); }
  /* The veil is made here, on <body>: in the header's markup a fixed element
     is clipped to the sticky header, and Horizon's re-render puts it back. */
  function V() {
    var v = document.getElementById('mega-veil');
    if (!v) {
      v = document.createElement('div');
      v.id = 'mega-veil';
      v.className = 'mega-veil';
      v.setAttribute('data-mega-veil', '');
      v.setAttribute('aria-hidden', 'true');
      document.body.appendChild(v);
    }
    return v;
  }
  function rows() { var p = P(); return p ? Array.prototype.slice.call(p.querySelectorAll('.mega__row')) : []; }
  function header() { return document.getElementById('header-component'); }

  function isTrigger(el) {
    if (!el || !el.closest) return null;
    var a = el.closest('#header-component a, #header-component button');
    if (!a || a.closest('#mega-shop, .np-mobile-menu, .menu-drawer, header-drawer')) return null;
    var t = a.textContent.trim().toLowerCase();
    return t === 'магазин' || t === 'shop' ? a : null;
  }

  function findTrigger() {
    var links = document.querySelectorAll('#header-component a, #header-component button');
    for (var i = 0; i < links.length; i++) {
      if (isTrigger(links[i]) === links[i] && links[i].getClientRects().length) return links[i];
    }
    return null;
  }

  function hasCurrent() { return rows().some(function (r) { return r.hasAttribute('data-current'); }); }

  /* Attributes on the trigger, (re)applied after every header re-render. */
  function mark() {
    var t = findTrigger();
    if (!t) return;
    lastTrigger = t;
    if (!t.classList.contains('mega-trigger')) t.classList.add('mega-trigger');
    if (hasCurrent() && !t.classList.contains('is-current')) t.classList.add('is-current');
    if (t.getAttribute('aria-controls') !== 'mega-shop') {
      t.setAttribute('aria-controls', 'mega-shop');
      t.setAttribute('aria-haspopup', 'true');
    }
    var want = isOpen ? 'true' : 'false';
    if (t.getAttribute('aria-expanded') !== want) t.setAttribute('aria-expanded', want);
  }

  function activeIndex() {
    var rs = rows();
    for (var i = 0; i < rs.length; i++) if (rs[i].classList.contains('is-active')) return i;
    return -1;
  }

  function defaultIndex() {
    var rs = rows();
    for (var i = 0; i < rs.length; i++) if (rs[i].hasAttribute('data-current')) return i;
    return 0;
  }

  function buildImages() {
    var p = P();
    if (!p) return;
    var box = p.querySelector('[data-mega-imgs]');
    if (!box || box.children.length) return;
    var act = activeIndex();
    rows().forEach(function (row, i) {
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      if (i !== act) img.setAttribute('fetchpriority', 'low');
      img.src = row.dataset.img || '';
      if (i === act) img.classList.add('is-active');
      box.appendChild(img);
    });
  }

  function setActive(i, force) {
    var p = P();
    var rs = rows();
    if (!p || i < 0 || i >= rs.length) return;
    if (!force && i === activeIndex()) return;
    rs.forEach(function (r, k) { r.classList.toggle('is-active', k === i); });
    var imgs = p.querySelectorAll('[data-mega-imgs] img');
    Array.prototype.forEach.call(imgs, function (im, k) { im.classList.toggle('is-active', k === i); });
    var row = rs[i];
    var total = p.dataset.total || String(rs.length).padStart(2, '0');
    var set = function (sel, text) { var el = p.querySelector(sel); if (el) el.textContent = text; };
    set('[data-mega-cap-title]', row.dataset.label || '');
    set('[data-mega-cap-meta]', row.dataset.meta || '');
    set('[data-mega-count]', String(i + 1).padStart(2, '0') + ' / ' + total);
    var see = p.querySelector('[data-mega-see]');
    if (see) see.href = row.getAttribute('href');
  }

  function place() {
    var p = P();
    var v = V();
    if (!p || !v) return;
    v.style.setProperty('--mega-top', Math.max(0, p.getBoundingClientRect().top) + 'px');
  }

  function open(focusFirst) {
    clearTimeout(closeTimer);
    openTimer = null;
    var p = P();
    if (!p || !desktop.matches) return;
    if (activeIndex() < 0) setActive(defaultIndex(), true);
    if (isOpen) {
      if (focusFirst) { var r0 = rows()[activeIndex()]; if (r0) r0.focus(); }
      return;
    }
    isOpen = true;
    buildImages();
    p.removeAttribute('inert');
    p.classList.remove('is-open');
    void p.offsetWidth;
    p.classList.add('is-open');
    place();
    var v = V();
    if (v) v.classList.add('is-on');
    var h = header();
    if (h) h.classList.add('force-solid-bg');
    mark();
    openScrollY = window.scrollY;
    if (focusFirst) setTimeout(function () { var r = rows()[activeIndex()]; if (r) r.focus(); }, 60);
  }

  function close(returnFocus) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    openTimer = null;
    if (!isOpen) return;
    isOpen = false;
    var p = P();
    if (p) {
      p.classList.remove('is-open');
      p.setAttribute('inert', '');
    }
    var v = V();
    if (v) v.classList.remove('is-on');
    var h = header();
    if (h) h.classList.remove('force-solid-bg');
    mark();
    if (returnFocus && lastTrigger) lastTrigger.focus();
    setActive(defaultIndex(), true);
  }

  function scheduleClose() {
    clearTimeout(openTimer);
    openTimer = null;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { close(false); }, 200);
  }

  function inPanel(el) { return !!(el && el.closest && el.closest('#mega-shop')); }

  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  function init() {
    V();
    setActive(defaultIndex(), true);
    mark();

    var h = header();
    if (h && 'MutationObserver' in window) {
      // The search placeholder types itself, so the header mutates often:
      // re-mark at most once a frame. A re-rendered panel gets its state back.
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          mark();
          var p = P();
          if (p && activeIndex() < 0) setActive(defaultIndex(), true);
          if (p && isOpen && !p.classList.contains('is-open')) {
            buildImages();
            p.classList.add('is-open');
            p.removeAttribute('inert');
          }
        });
      }).observe(h, { childList: true, subtree: true });
    }

    document.addEventListener('pointerover', function (e) {
      if (!desktop.matches) return;
      var t = isTrigger(e.target);
      if (t) {
        if (e.relatedTarget && isTrigger(e.relatedTarget) === t) return;
        lastTrigger = t;
        buildImages();
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (!isOpen) openTimer = setTimeout(function () { open(false); }, 120);
        return;
      }
      if (inPanel(e.target)) clearTimeout(closeTimer);
    });

    /* Rows follow the moving pointer, not pointerover: when the cascade or
       the arrow keys move rows under a resting cursor, the keyboard keeps
       the choice. */
    document.addEventListener('pointermove', function (e) {
      if (!isOpen) return;
      var row = e.target.closest && e.target.closest('#mega-shop .mega__row');
      if (row) setActive(+row.dataset.index);
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      if (!isOpen && !openTimer) return;
      var from = isTrigger(e.target) || inPanel(e.target);
      if (!from) return;
      var to = e.relatedTarget;
      if (to && (isTrigger(to) || inPanel(to))) return;
      scheduleClose();
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (desktop.matches) {
        var t = isTrigger(e.target);
        if (t) {
          // A click on "Магазин" goes to the catalogue, as before the mega
          // menu (Alik, 16.10.2026); the menu opens on hover, and from the
          // keyboard on Enter / Space / ↓ (keydown below).
          lastTrigger = t;
          return;
        }
      }
      if (e.target.closest('[data-mega-veil]')) { close(false); return; }
      var row = e.target.closest('#mega-shop .mega__row');
      if (row) track('mega_shop_click', { category: row.dataset.label, position: +row.dataset.index + 1 });
      if (e.target.closest('#mega-shop [data-mega-see]')) {
        var a = rows()[activeIndex()];
        track('mega_shop_click', { category: a && a.dataset.label, position: activeIndex() + 1, via: 'photo' });
      }
      if (e.target.closest('#mega-shop [data-mega-size]') && typeof window.openSizeGuide === 'function') {
        e.preventDefault();
        close(false);
        window.openSizeGuide();
      }
    }, true);

    document.addEventListener('focusin', function (e) {
      var row = e.target.closest && e.target.closest('#mega-shop .mega__row');
      if (row) setActive(+row.dataset.index);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { close(true); return; }
      if (!desktop.matches) return;
      var t = isTrigger(e.target);
      if (t) {
        lastTrigger = t;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); open(true); }
        return;
      }
      var row = e.target.closest && e.target.closest('#mega-shop .mega__row');
      if (!row) return;
      var rs = rows();
      var i = +row.dataset.index;
      if (e.key === 'ArrowDown' && rs[i + 1]) { e.preventDefault(); rs[i + 1].focus(); }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (rs[i - 1]) rs[i - 1].focus(); else if (lastTrigger) lastTrigger.focus();
      }
    });

    window.addEventListener('scroll', function () {
      if (isOpen && Math.abs(window.scrollY - openScrollY) > 80) close(false);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (isOpen && !desktop.matches) close(false);
      else if (isOpen) place();
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
